import { CHART_KEYS, COLUMNS } from './keys';
import { query } from './query';
import DataTable from '../../../../components/Datatable';
import Component from '../../../../components/Component';
import { getDifference } from '../../../../helpers/showDelta';
import { noDataMessage } from '../../../../helpers/noDataMessage';
import Loading from '../../../../components/Loading';
import Timeline from '../../../../components/Timeline';
import { scrollForTable } from '../../../../components/Datatable/utils';
import { colors } from '../../../../lib/colors';
import { withTranslation } from 'react-i18next';

class CTR extends Component {
    constructor(props) {
        super();
        if (!props.data) this.query = query(props.dates);
    }

    searchFunction(data) {
        return data;
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.dates) !== JSON.stringify(this.props.dates)) {
            this.props.updateDates({ key: 'ctr', value: null });
            this.setState({ loading: true, data: null });
            this.query = query(this.props.dates);
            this.query.bind(this.setState.bind(this));
            this.query.update();
            this.props.updateDates({ emptyAll: true });
        }
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDates({ key: 'ctr', value: this.state.data });
        }
    }

    render() {
        const { t } = this.props;

        const data = this.state.data?.length ? this.state.data : this.props.data;
        if ((!data || !data.length) && this.state.loading && !this.props.data)
            return <Loading padding={10} />;

        const sortFns = {
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            avgCTR: (array) =>
                array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            keywords: (array) => array.sort((a, b) => a.keywords - b.keywords),
            impressions_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.impressions, a.impressionsPrior) -
                        getDifference(b.impressions, b.impressionsPrior),
                ),
            clicks_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.clicks, a.clicksPrior) -
                        getDifference(b.clicks, b.clicksPrior),
                ),
            keywords_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.keywords, a.keywordsPrior) -
                        getDifference(b.keywords, b.keywordsPrior),
                ),
            avgCTR_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.avgCTR, a.avgCTRPrior) -
                        getDifference(b.avgCTR, b.avgCTRPrior),
                ),
        };

        const chartData = (datasetIndex) => ({
            labels: data?.map((x) => x.position),
            datasets: CHART_KEYS(t).map((item, i) => ({
                label: item.label,
                type: 'line',
                data: data?.map((state) =>
                    item.render ? item.render(state[item.key]) : state[item.key],
                ),
                backgroundColor: colors[i],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                borderDash: item.borderDash ?? [0],
                borderRadius: 4,
                tension: 0.4,
            })),
        });

        return !data || !data.length ? (
            <div>{noDataMessage}</div>
        ) : (
            <div id="comparision-ctr">
                <div className="row card-row" id="comparision-ctr-chart">
                    <div className="col-12">
                        <div className="card rounded-main overflow-hidden">
                            <div className="card-body">
                                <Timeline
                                    chartSize="lg"
                                    dontShowMetrics
                                    data={data}
                                    error={this.state.error}
                                    keys={CHART_KEYS(t)}
                                    xAxis="position"
                                    chartData={chartData}
                                    forceRun={this.forceRun}
                                    leftAxisLabel={t('global.ctr_per')}
                                    xAxisTitle={t('global.position')}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row card-row" id="comparision-ctr-chart-table">
                    <div className="col-12">
                        <div className="card table-main rounded-main overflow-hidden">
                            <DataTable
                                nodes={data}
                                sortFns={sortFns}
                                COLUMNS={COLUMNS(t)}
                                uniqKey={'position'}
                                fileName={t('search.comparison.ctr.header')}
                                header={t('search.comparison.ctr.header')}
                                searchFunction={this.searchFunction}
                                forceRun={this.forceRun}
                                onlyTable
                                onlyPagination
                                additionalStyles={{
                                    Table: `
                                            --data-table-library_grid-template-columns : minmax(120px, 1fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(150px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(150px, 1fr) minmax(180px, 1.8fr) !important;
                                           ${scrollForTable}
                                            `,
                                    BaseCell: ` font-family: 'Raleway';
                                                    font-weight: 500;
                                                    font-size: 16px;
                                                    line-height: 19px;
                                                    padding: 16px 10px;
                                                    color: #0D182C;
                                                
                                                
                                                    &.underline {
                                                    text-decoration: underline;
                                                    }`,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(CTR);
